export default __webpack_public_path__ + "static/my-pies-9bb1e66ec836d6db41f8624f2aaac28d.svg";